import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CountryCodePipe } from '../../../../../shared/pipes/country-code.pipe';
import { SbAnimatedNumberComponent } from '../../../../../shared/components/sb-animated-number/sb-animated-number.component';
import { SbCompanyLogoComponent } from '../../../../../shared/components/sb-company-logo/sb-company-logo.component';
import { SbSubAccountsPipe } from '../../pipes/sb-sub-accounts.pipe';
import { TablerIconsModule } from 'angular-tabler-icons';
import { RouterLink } from '@angular/router';
import { AccountIssuersQuery } from '../../../../../pages/admin/state/account-issuers/account-issuers.query';
import { AcctsQuery } from '../../../../../shared/state/accts/accts.query';
import { KeyFigureElement } from '@widgets';
import {
    fadeInOut,
    list,
    slideInOut
} from '../../../../../shared/animations/fade-in-out.animation';

@Component({
    selector: 'sb-list-sub-accounts',
    standalone: true,
    imports: [
        CommonModule,
        CountryCodePipe,
        SbAnimatedNumberComponent,
        SbCompanyLogoComponent,
        SbSubAccountsPipe,
        TablerIconsModule,
        RouterLink
    ],
    templateUrl: './sb-list-sub-accounts.component.html',
    styleUrls: ['./sb-list-sub-accounts.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: [list, slideInOut]
})
export class SbListSubAccountsComponent {
    get showSubAccounts(): boolean {
        return this._showSubAccounts;
    }

    set showSubAccounts(value: boolean) {
        this._showSubAccounts = value;
    }
    get dataElements(): Array<KeyFigureElement> {
        return this._dataElements;
    }

    @Input() set dataElements(value: Array<KeyFigureElement>) {
        this._dataElements = value;
    }
    constructor(
        private _accountIssuerQuery: AccountIssuersQuery,
        private _accountsQuery: AcctsQuery
    ) {}
    accounts$ = this._accountsQuery.accountsAsObject$;
    issuers$ = this._accountIssuerQuery.allAsObject$;
    private _dataElements: Array<KeyFigureElement> = [];
    private _showSubAccounts = false;
    trackByFn = (index: number, item: any) => item.id;
    toggleSubAccounts() {
        this.showSubAccounts = !this.showSubAccounts;
    }
}
